import { type FC } from "react";
import { twMerge } from "tailwind-merge";

import { SessionButton } from "./SessionButton";
import { UnsupportedDeviceBanner } from "./UnsupportedDeviceBanner";
import { ImportSectionButton } from "./content/ImportSectionButton";

import { t } from "i18n/i18n";
import { Tooltip } from "mds/components/Tooltip";
import { useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import {
  selectCurrentCourseTitle,
  selectCurrentOrgName,
  selectCurrentSectionDescription,
  selectCurrentSectionHasMaterials,
  selectCurrentSectionId,
  selectCurrentSectionTitle,
  selectCurrentTermTitle,
} from "store/selectors";

type SectionTitleBarProps = {
  className?: string;
};

export const SectionTitleBar: FC<SectionTitleBarProps> = ({ className }) => {
  const sectionId = useAppSelector(selectCurrentSectionId);
  const sectionTitle = useAppSelector(selectCurrentSectionTitle);
  const sectionDescription = useAppSelector(selectCurrentSectionDescription);
  const { canAuthorSection } = useCapabilities();
  const orgName = useAppSelector(selectCurrentOrgName);
  const courseTitle = useAppSelector(selectCurrentCourseTitle);
  const termTitle = useAppSelector(selectCurrentTermTitle);
  const hasMaterials = useAppSelector(selectCurrentSectionHasMaterials);

  if (!sectionId) {
    return null;
  }

  return (
    <>
      <div
        className={twMerge(
          "flex w-full flex-col justify-between gap-4 sm:flex-row sm:items-center",
          className,
        )}
      >
        <div className="flex w-full flex-col items-baseline gap-2 xl:flex-row xl:gap-4">
          <div className="flex flex-row items-center gap-4">
            <h2 className="flex items-center justify-between text-2xl text-black-tint-20">
              {sectionTitle}
            </h2>

            {canAuthorSection && !hasMaterials && <ImportSectionButton />}
          </div>

          {orgName && termTitle && courseTitle && (
            <div className="flex flex-row items-center gap-2 border-black text-base text-black-tint-20 xl:border-l xl:pl-4">
              {orgName}, {termTitle} - {courseTitle}
              {sectionDescription && (
                <Tooltip label={t("tooltip.view.course_description")} text={sectionDescription} />
              )}
            </div>
          )}
        </div>

        <SessionButton />
      </div>
      <UnsupportedDeviceBanner />
    </>
  );
};
